import axios from '@/api/config';
const examResult = {
    dataStatisticsForSequence(data) {
        return axios.post(`${process.env.BASE_URL}/examResult/dataStatisticsForSequence`, data)
    },
    dataStatisticsForClass(data) {
        return axios.post(`${process.env.BASE_URL}/examResult/dataStatisticsForClass`, data)
    },
}
export default examResult



// WEBPACK FOOTER //
// ./src/api/examResult.js